import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { C, field, btnPrimary, softShadow } from "../lib/theme";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function ResetPassword() {
  const { resetPassword } = useAuth();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("La password deve avere almeno 6 caratteri"); return; }
    if (password !== confirm) { toast.error("Le password non coincidono"); return; }
    setLoading(true);
    try {
      await resetPassword(token, password);
      toast.success("Password aggiornata! Ora puoi accedere.");
      nav("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-5 py-12">
      <div className="w-full max-w-md bg-white rounded-3xl p-8 sm:p-10" style={softShadow} data-testid="reset-card">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-11 h-11 rounded-2xl flex items-center justify-center" style={{ background: C.CORAL }}>
            <KeyRound className="w-6 h-6 text-white" />
          </span>
          <span className="font-display text-2xl font-extrabold" style={{ color: C.INK }}>Nuova password</span>
        </div>
        {!token ? (
          <>
            <p className="text-sm mt-4 mb-6" style={{ color: C.MUTED }}>Link non valido o incompleto. Richiedi un nuovo link di reset.</p>
            <Link to="/password-dimenticata" className={`${btnPrimary} inline-flex`}>Richiedi nuovo link</Link>
          </>
        ) : (
          <>
            <p className="text-sm mb-8" style={{ color: C.MUTED }}>Scegli una nuova password per il tuo account.</p>
            <form onSubmit={submit} className="space-y-5">
              <div>
                <label className="block text-sm font-semibold mb-2" style={{ color: "#4a453f" }}>Nuova password</label>
                <input data-testid="reset-password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className={field} placeholder="Min. 6 caratteri" />
              </div>
              <div>
                <label className="block text-sm font-semibold mb-2" style={{ color: "#4a453f" }}>Conferma password</label>
                <input data-testid="reset-confirm" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className={field} placeholder="Ripeti la password" />
              </div>
              <button data-testid="reset-submit" disabled={loading} className={`${btnPrimary} w-full`}>
                {loading ? "Salvataggio…" : "Aggiorna password"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
